import { motion } from "framer-motion";
import { FOUNDER } from "../../lib/site-data";
import SectionLabel from "./SectionLabel";

const PARAGRAPHS = [
  "A few years ago, I started noticing something. Some of the biggest opportunities, ideas and turning points in my life weren’t planned. They happened because I met the right people.",
  "Staying across Pune, Gurugram and Indore introduced me to people from completely different backgrounds and professions.",
  "It made me realise how much can happen when the right people find each other. One meaningful conversation can lead to a collaboration, a client, a mentor, a friendship, or simply a new perspective.",
  "That belief is what led me to build High Five Access: a curated community where professionals can build meaningful relationships, discover opportunities and grow alongside the right people.",
];

export default function Founder() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="section-pad bg-white text-black"
    >
      <div className="container-x">
        <div className="max-w-4xl mb-8 md:mb-10">
          <SectionLabel>Built with Intention</SectionLabel>
          <h2
            data-testid="founder-headline"
            className="font-display mt-8 text-xl md:text-2xl font-bold tracking-tightest leading-[1.05]"
          >
            The Person Behind{" "}
            <span className="whitespace-nowrap">High Five Access</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="grid grid-cols-1 sm:grid-cols-12 gap-8 md:gap-12 items-start"
        >
          <div className="sm:col-span-4 flex justify-center sm:justify-start sm:sticky sm:top-24">
            <div className="flex flex-col items-center">
              <div
                data-testid="founder-photo"
                className="relative w-44 h-44 sm:w-52 sm:h-52 md:w-56 md:h-56 rounded-2xl overflow-hidden border border-black/10 shadow-[0_24px_50px_-20px_rgba(0,0,0,0.25)]"
              >
                <img
                  src={FOUNDER.photo}
                  alt={FOUNDER.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="mt-5 text-center w-full">
                <div
                  data-testid="founder-name"
                  className="font-display text-xl md:text-2xl font-semibold tracking-tight"
                >
                  {FOUNDER.name}
                </div>
                <div className="text-sm md:text-base text-orange-600 font-medium mt-1">
                  {FOUNDER.title}
                </div>
                <div className="mt-3 flex justify-center">
                  <a
                    href="https://linkedin.com/in/carahulbhojwani"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="founder-linkedin"
                    aria-label="CA Rahul Bhojwani on LinkedIn"
                    className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-[#0A66C2] hover:bg-[#0958a8] text-white transition-colors shadow-[0_6px_16px_-8px_rgba(10,102,194,0.55)]"
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                      <path d="M20.451 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.446-2.136 2.94v5.666H9.355V9h3.414v1.561h.048c.476-.9 1.637-1.852 3.37-1.852 3.601 0 4.267 2.37 4.267 5.455v6.288zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.777 13.019H3.56V9h3.554v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            className="sm:col-span-8 space-y-5 text-[15px] md:text-lg text-black/75 leading-relaxed text-left"
            data-testid="founder-note"
          >
            {PARAGRAPHS.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
